export enum RoutePath {
    Home = 'home',
    Login = 'login',
    PageNotFound = '404',
    PageNotAuthorized = 'unauthorized',
    CalendarWidget = 'calendarwidget',
    Events = 'events',
    Feeds = 'feeds',
    Feeds2 = 'feeds2',
    Bulletin = 'bulletin',
    HallOfFame = 'halloffame',
    LegislationInfo = 'legislativeitems',
    LegislationGroups = 'legislativegroups',
    LegislationForm = 'legislativeform',
    Categories = 'categories',
    Schools = 'schools',
    // Roles = 'roles',
    // User = 'users'
    UserRoles = 'userroles',
    Maintenance = 'maintenance',
    DevTestPage = 'devtestpage',
}
